import React, { Component } from 'react'
import { connect } from 'react-redux'

const faqContainer = (ComposedComponent) => {
    class FaqContainer extends Component {
        render() {
            return (
                <ComposedComponent {...this.props} />
            )
        }
    }
    const mapStateToProps = ({
        langs: { indexLang },
        faq: { isSending, succeeded },
        boxSubscription: { modal, title, text },
    }) => ({
        indexLang,
        isSending,
        succeeded,
        modal,
        title,
        text,
    })
    return connect(mapStateToProps)(FaqContainer)
}

export default faqContainer
